var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Table from '../Table/Table';
import { AddonsWrapper, TotalInfo, TotalInfoWrapper, AddonCancel, QuantityUpdateWrapper, QuantitySubtract, Quantity, QuantityAdd, } from './styles';
import { Button } from '@appspotr/ui-kit';
import { getBundlesTotal, getIncludedCapabilities, exractAddonsFromActiveBindles, } from './helper';
import { DEFAULT_CURRENCY, priceBuilder } from '../../utils/currency';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import cloneDeep from 'lodash/cloneDeep';
import AddonConfirmModal from './AddonConfirmModal';
var intervalDescriptor = {
    month: 'mo',
    year: 'yr',
};
var AddonsComponent = function (_a) {
    var bundles = _a.bundles, activeBundles = _a.activeBundles, updateActiveBundles = _a.updateActiveBundles, updatedAddons = _a.updatedAddons, updateUpdatedAddons = _a.updateUpdatedAddons, activeDeveloperPlan = _a.activeDeveloperPlan, onUpdateAddons = _a.onUpdateAddons, devPlanInvoiceDetails = _a.devPlanInvoiceDetails, getProratedAmountForAddons = _a.getProratedAmountForAddons, proratedAmountForAddons = _a.proratedAmountForAddons;
    var dispatch = useDispatch();
    var _b = useState(false), openAddonConfirmModal = _b[0], setOpenAddonConfirmModal = _b[1];
    var Columns = [
        {
            accessor: 'addon',
            Header: 'Addon',
            textAlign: 'start',
            disableSortBy: true,
        },
        {
            accessor: 'apps',
            Header: 'Apps',
            disableSortBy: true,
        },
        {
            accessor: 'pwa',
            Header: 'PWA',
            disableSortBy: true,
        },
        {
            accessor: 'ios',
            Header: 'iOS',
            disableSortBy: true,
        },
        {
            accessor: 'android',
            Header: 'Android',
            disableSortBy: true,
        },
        {
            accessor: 'price',
            Header: 'Price',
            disableSortBy: true,
        },
        {
            accessor: 'qty',
            Header: 'Qty',
            disableSortBy: true,
        },
        {
            accessor: 'total',
            Header: 'Total',
            disableSortBy: true,
        },
    ];
    var addones = exractAddonsFromActiveBindles(activeBundles, activeDeveloperPlan === null || activeDeveloperPlan === void 0 ? void 0 : activeDeveloperPlan.bundles_with_prices);
    var addonsTotal = getBundlesTotal(addones);
    var includedCapabilities = getIncludedCapabilities(activeDeveloperPlan);
    var updateActiveBundlesOnclick = function (row, updateType) {
        /*updateActiveBundles*/
        var found = false;
        var updatedBundles = cloneDeep(activeBundles);
        updatedBundles.map(function (item, index) {
            if (item.bundle.id === row.bundle.id) {
                found = true;
                updatedBundles[index].quantity =
                    updateType === 'add' ? item.quantity + 1 : item.quantity - 1;
            }
        });
        !found && updatedBundles.push(row);
        updateActiveBundles(updatedBundles.filter(function (item) { return item.quantity !== 0; }));
        /*updateUpdatedAddons - using this for protated amoount & add/remove addones*/
        var addonsFound = false;
        var addons = cloneDeep(updatedAddons);
        addons.map(function (item, index) {
            if (item.bundle.id === row.bundle.id) {
                addonsFound = true;
                addons[index].quantity =
                    updateType === 'add' ? item.quantity + 1 : item.quantity - 1;
            }
        });
        if (!addonsFound) {
            var rowToPush = cloneDeep(row);
            rowToPush.quantity = updateType === 'subtract' ? -1 : 1;
            addons.push(rowToPush);
        }
        updateUpdatedAddons(addons.filter(function (item) { return item.quantity !== 0; }));
    };
    var quantityUpdate = function (quantity, row) {
        return (_jsxs(QuantityUpdateWrapper, { children: [_jsx(QuantitySubtract, __assign({ onClick: function () {
                        quantity > 0 && updateActiveBundlesOnclick(row, 'subtract');
                    } }, { children: "-" })), _jsx(Quantity, { children: quantity }), _jsx(QuantityAdd, __assign({ onClick: function () {
                        updateActiveBundlesOnclick(row, 'add');
                    } }, { children: "+" }))] }));
    };
    var getRows = function () {
        var rows = bundles.map(function (row) {
            var findInAddons = addones.find(function (item) { return item.bundle.id === row.bundle.id; });
            var quantity = findInAddons ? findInAddons.quantity : 0;
            var amount = row.final_price[row.bundle.currency].amount;
            var total = (quantity * amount).toString();
            return {
                id: row.bundle.id,
                addon: row.bundle.name,
                apps: row.bundle.meta.apps,
                pwa: row.bundle.meta.pwa,
                ios: row.bundle.meta.ios,
                android: row.bundle.meta.android,
                price: priceBuilder(amount, row.bundle.currency || DEFAULT_CURRENCY),
                qty: quantityUpdate(quantity, row),
                total: priceBuilder(total, row.bundle.currency || DEFAULT_CURRENCY),
            };
        });
        if (rows[rows.length - 1]) {
            rows[rows.length - 1].darkBorder = true;
        }
        rows.push({
            id: 'addon_total',
            addon: _jsx("b", { children: "Addons Total" }),
            apps: _jsx("b", { children: addonsTotal.apps }),
            pwa: _jsx("b", { children: addonsTotal.pwa }),
            ios: _jsx("b", { children: addonsTotal.ios }),
            android: _jsx("b", { children: addonsTotal.android }),
            total: (_jsx("b", { children: priceBuilder(addonsTotal.cost, activeDeveloperPlan.currency || DEFAULT_CURRENCY) })),
            darkBorder: true,
        });
        rows.push({
            id: 'dev_plan',
            addon: _jsx("b", { children: "Developer Plan" }),
            apps: _jsx("b", { children: includedCapabilities.apps }),
            pwa: _jsx("b", { children: includedCapabilities.pwa }),
            ios: _jsx("b", { children: includedCapabilities.ios }),
            android: _jsx("b", { children: includedCapabilities.android }),
            total: (_jsx("b", { children: priceBuilder(includedCapabilities.cost, activeDeveloperPlan.currency || DEFAULT_CURRENCY) })),
            darkBorder: true,
        });
        return rows;
    };
    return (_jsxs(AddonsWrapper, { children: [_jsx(AddonConfirmModal, { isVisible: openAddonConfirmModal, setIsVisible: setOpenAddonConfirmModal, primaryButtonAction: function () {
                    onUpdateAddons(updatedAddons);
                    setOpenAddonConfirmModal(false);
                }, addonsTotal: addonsTotal, includedCapabilities: includedCapabilities, devPlanInvoiceDetails: devPlanInvoiceDetails, proratedAmountForAddons: proratedAmountForAddons, updatedAddons: updatedAddons }), _jsx(Table, { columns: Columns, data: getRows(), pageSize: 100, hidePagination: true, noBorder: true }), _jsxs(TotalInfoWrapper, { children: [_jsx(TotalInfo, { children: _jsx("div", { children: _jsx("b", { children: "Total" }) }) }), _jsx(TotalInfo, { children: _jsx("div", { children: _jsxs("b", { children: [priceBuilder(addonsTotal.cost + includedCapabilities.cost, activeDeveloperPlan.currency || DEFAULT_CURRENCY), "/", intervalDescriptor[activeDeveloperPlan.interval]] }) }) })] }), _jsxs(TotalInfoWrapper, { children: [_jsx(AddonCancel, __assign({ onClick: function () {
                            dispatch(push("usage"));
                        } }, { children: "Cancel Changes" })), _jsx(Button, __assign({ disabled: !updatedAddons.length, onClick: function () {
                            setOpenAddonConfirmModal(true);
                            var restructureedUpdatedBundles = updatedAddons.map(function (addon) {
                                return { bundle: addon.bundle.id, quantity: addon.quantity };
                            });
                            getProratedAmountForAddons(restructureedUpdatedBundles);
                        } }, { children: "Update addons" }))] })] }));
};
export default AddonsComponent;
